export const clamp = (number: number, min = 0, max = 1): number =>
    number > max ? max : number < min ? min : number

